export const FIRMWARE_TIMEOUT_MINUTES = {
  MIN: 0,
  MAX: 600,
  DEFAULT: 30,
} as const

export function toFirmwareTimeoutMinutes(value: number | string | null | undefined): number | null {
  const minutes = typeof value === 'number' ? value : parseInt(value ?? '', 10)
  return Number.isInteger(minutes) ? minutes : null
}
